import '@opten/gin-tonic/components/image';
import { factory } from '@opten/gin-tonic/helpers/compiler';
import { CollapseComponent } from '../libs/gin-tonic/components/collapse/component';
import { DialogComponent } from './components/dialog/dialog';
import { FilterComponent } from './components/filter/filter';
import { PreValueComponent } from './components/form/prevalue';
import { SearchComponent } from './components/search/search';
import { ShareComponent } from './components/share/share';
import { CopyToClipboardComponent } from './components/sidebar/copy-to-clipboard';
import { SidebarComponent } from './components/sidebar/sidebar';
import { SwiperComponent } from './components/slider/slider';
import { CountUpComponent } from './components/sustainability/count-up';
import { TableComponent } from './components/table/table';
import './main.scss';
import { VideoBackgroundComponent } from './components/video-background/index';
import { CookiebotRenewComponent } from './components/cookiebot/cookiebotrenew';
import { FormFieldComponent } from '../libs/gin-tonic/components/form-field/component';

const l = factory([
	CollapseComponent,
	DialogComponent,
	CopyToClipboardComponent,
	SidebarComponent,
	SwiperComponent,
	FilterComponent,
	SearchComponent,
	PreValueComponent,
	ShareComponent,
	CountUpComponent,
	TableComponent,
	VideoBackgroundComponent,
	CookiebotRenewComponent,
	FormFieldComponent
]);
l(document.body);
